/********************************************************************
 * Project: WDCK（2021）
 * Class:AlphaNumeric Directive
 * ----------------------------------------
 * <summary>
 * AlphaNumeric format
 * </summary>
 * <history>
 *      NghiaNX     2021/09/16      Create
 * </history>
 ********************************************************************/
 import { Directive, ElementRef, HostListener } from '@angular/core';

 @Directive({
     selector: 'input[alphaNum]'
 })
 export class AlphaNumericDirective {
     dobRegex = /[^0-9a-zA-Z]/g;
     constructor(private el: ElementRef) {
     }

     @HostListener('input', ['$event']) onInputChange(event) {
         const initalValue = this.el.nativeElement.value;
         this.el.nativeElement.value = initalValue.replace(this.dobRegex, '');
         if (initalValue !== this.el.nativeElement.value) {
             event.stopPropagation();
         }
     }
 }
